export class MapUtil {
  public static update<K, V>(
    map: Map<K, V>,
    key: K,
    cb: (item: V | undefined) => V | undefined
  ): void {
    const value = map.get(key)
    const newValue = cb(value)
    if (newValue === undefined) {
      map.delete(key)
    } else {
      map.set(key, newValue)
    }
  }
}
